import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import router from "./routes/Routes.js";
import store from "./store/index.js";
import * as VueGoogleMaps from "vue2-google-maps";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
//import CxltToastr from "cxlt-vue2-toastr";

import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from "vee-validate/dist/vee-validate.full";
import es from "vee-validate/dist/locale/es.json";
import VueNativeNotification from "vue-native-notification";

import axios from "axios";
import VueAxios from "vue-axios";

import { auth } from "@/firebase";

Vue.use(VueAxios, axios);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
localize("es", es);

Vue.use(VueNativeNotification, {
  requestOnNotify: true,
});
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter((t) => t.type === toast.type).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  },
});

const options = {
  confirmButtonColor: "#1976d2",
  cancelButtonColor: "#e71e1b",
};
Vue.use(VueSweetalert2, options);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLEMAPKEY,
    // key: process.env.VUE_APP_GOOGLEMAPKEY_SANDBOX,
    libraries: "places",
  },
});

Vue.config.productionTip = false;

let app = null;

// eslint-disable-next-line no-unused-vars
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      vuetify,
      store,
      router,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
